// ============================================
// AD HOC FEE HOOKS
// Combines hooks from:
// - [BuilderAdHocFee.tsx] BuilderAdHocFee (top-level) (ADHOC FEES 3350-3351)
// ============================================

import {AutoFieldHelpers} from '../../../components/AutoForm/useAutoForm';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {adHocFeeFieldType} from '../BuilderAdHocFee/builderAdHocFeeFields';
import {OVRecommendation} from '../../../schema-types/OVRecommendation';
import {OvbuilderDetails_ovrecommendDetails} from '../../../schema-types/OvbuilderDetails';
import FREQUENCY from '../../../constants/Frequency';
import {initialAdHocFee} from '../BuilderAdHocFee/BuilderAdHocFields';
import {UPDATES} from '../../../shared/UPDATES';
import {AdhocFeeTypeEnum} from '../../../schema-types/globalTypes';

export const loadSavedAdHocFee = ({
  builderDetails,
  adhocHelpers,
}: {
  builderDetails: OvbuilderDetails_ovrecommendDetails | null;
  adhocHelpers: AutoFieldHelpers<adHocFeeFieldType | undefined>;
}) => {
  if (!builderDetails) {
    // if no data, just use the initial one
    adhocHelpers.setValue(UPDATES._D3350, initialAdHocFee);
    return;
  }
  const savedSource = builderDetails?.potPlans?.find((p) => p.planType === 'source');
  // sometimes the crystallised ammount will be on the parent pot, so we check it too
  const parentSource = builderDetails?.potPlans?.find(
    (p) => p.id === savedSource?.pot.parent?.id
  );
  const isMonetary = savedSource?.adhocFeeType === '£';

  const savedAdHocFee: builderFieldsType['adHocFee'] = {
    feeType: isMonetary ? AdhocFeeTypeEnum.GBP : AdhocFeeTypeEnum.PERCENT,
    frequency: FREQUENCY.SINGLE,
    // instructionDate: savedSource?.adhocFeeDate,
    monetaryFee: isMonetary ? Number(savedSource?.adhocFeeAmount) : 0,
    percentFee: isMonetary ? 0 : Number(savedSource?.adhocFeeAmount),
    planId: savedSource?.pot.id,
    crystallised: !Number(savedSource?.pot.crystallisedFunds)
      ? parentSource?.pot.crystallisedFunds
      : savedSource?.pot.crystallisedFunds,
    uncrystallised: !Number(savedSource?.pot.uncrystallisedFunds)
      ? parentSource?.pot.uncrystallisedFunds
      : savedSource?.pot.uncrystallisedFunds,
    reason: savedSource?.adhocFeeReason ?? undefined,
    planValue: savedSource?.pot.totalValue,
  };
  adhocHelpers.setValue(UPDATES._D3351, savedAdHocFee, true);
};
